namespace $ {

	$mol_style_define( $shm_hitalama_map_history_view, {
		width: '30rem',
		maxWidth: '100vw',
		flex: {
			basis: '30rem',
			grow: 0,
			shrink: 0,
		},

		Head_spacer: {
			flex: {
				grow: 1,
			},
		},

		Event: {
			alignItems: 'stretch',
			textAlign: 'left',
			whiteSpace: 'normal',
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
			boxSizing: 'border-box',
			flex: {
				direction: 'column',
			},
			border: {
				bottom: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
			cursor: 'pointer',
		},

		Event_summary: {
			align: {
				items: 'flex-start',
			},
			gap: $mol_gap.text,
			width: '100%',
			minWidth: 0,
		},

		Event_title: {
			color: $mol_theme.text,
			whiteSpace: 'normal',
			wordBreak: 'break-word',
			minWidth: 0,
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Event_meta: {
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			maxWidth: '55%',
			textAlign: 'right',
			margin: {
				left: 'auto',
			},
			flex: {
				shrink: 0,
			},
		},

		Event_details: {
			whiteSpace: 'pre-wrap',
			wordBreak: 'break-word',
			overflowWrap: 'anywhere',
			minWidth: 0,
			width: '100%',
			color: $mol_theme.shade,
		},

		No_events: {
			color: $mol_theme.shade,
		},
	} )

}
